import React from "react"
import { splitMdxType } from "../../utils/mdxTypeUtils"
import style from "./Hero.module.scss"

export default ({ children }) => {
  const [ illustration, content, ] = splitMdxType('hr', children)
  return (
    <section className={style.container}>
      <aside>
        {illustration}
      </aside>
      <article>
        {content}
      </article>
    </section>
  )
}
